import React, { useState, useEffect } from 'react';
import NavBar from '../../components/navbar/navBarComponent';
import Breadcrumb from '../../components/breadcrumb/breadcrumbComponent';
import DiscountFeed from '../../components/discount-form/discountFeed';
import discountUtils from '../../utils/discount';
import Search from '../../components/search/searchComponent';
import PageControls from '../../components/table-pagination/pageControls';
import config from '../../config/tableConfig';

const PAGE_SIZE = 10;

const DiscountListPage = (props) => {
  const [discounts, setDiscounts] = useState([]);
  const [visible, setVisible] = useState([]);
  const [page, setPage] = useState(1);
  const [isFiltered, setIsFiltered] = useState(false);
  const [searchStr, setSearchStr] = useState('');
  const [showEnabledOnly, setShowEnabledOnly] = useState(false);

  const breadcrumbItems = [
    { name: 'Menu', link: '/menu' },
    { name: 'Descuentos', link: '/discounts' }
  ];

  useEffect(() => {
    async function load() {
      const res = await discountUtils.getAllDiscounts();
      if (res && res.success) {
        setDiscounts(res.data);
        const filtered = applyFilters(res.data, searchStr, showEnabledOnly);
        setVisible(filtered.slice(0, PAGE_SIZE));
        setPage(1);
        setIsFiltered(false);
      }
    }
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const applyFilters = (list, search = '', enabledOnly = false) => {
    let filtered = Array.isArray(list) ? list.slice() : [];
    if (enabledOnly) filtered = filtered.filter(d => !!d.enabled);

    const q = (search || '').toLowerCase().trim();
    if (!q) return filtered;

    const tokens = q.split(' ').filter(Boolean);
    const matchToken = (d, token) => {
      const typeStr = (d.type || '').toLowerCase();
      const titleStr = (d.title || '').toLowerCase();
      const valueStr = String(d.value == null ? '' : d.value).toLowerCase();
      const brandsStr = Array.isArray(d.brandList) ? d.brandList.join(' ').toLowerCase() : '';
      const productsStr = Array.isArray(d.productList) ? d.productList.join(' ').toLowerCase() : '';
      const dateStr = d.endDate ? new Date(d.endDate).toLocaleDateString(config.locales.region).toLowerCase() : '';
      return (
        typeStr.includes(token) ||
        titleStr.includes(token) ||
        valueStr.includes(token) ||
        brandsStr.includes(token) ||
        productsStr.includes(token) ||
        dateStr.includes(token)
      );
    };

    return filtered.filter(d => tokens.every(t => matchToken(d, t)));
  };

  const refreshList = async (p = page) => {
    const res = await discountUtils.getAllDiscounts();
    if (res && res.success) {
      setDiscounts(res.data);
      const filtered = applyFilters(res.data, searchStr, showEnabledOnly);
      setVisible(filtered.slice((p - 1) * PAGE_SIZE, p * PAGE_SIZE));
    }
  };

  const generateList = (list) =>
    list ? list.map(d => (
      <DiscountFeed
        key={d._id}
        discount={d}
        onToggle={async (id) => {
          await discountUtils.toggleEnabled(id);
          await refreshList();
        }}
        onDelete={async (id) => {
          await discountUtils.deleteDiscount(id);
          await refreshList();
        }}
      />
    )) : null;

  const nextPage = () => {
    const filtered = applyFilters(discounts, searchStr, showEnabledOnly);
    const maxPage = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    if (page < maxPage) {
      const next = page + 1;
      setVisible(filtered.slice((next - 1) * PAGE_SIZE, next * PAGE_SIZE));
      setPage(next);
    }
  };

  const prevPage = () => {
    if (page > 1) {
      const prev = page - 1;
      const filtered = applyFilters(discounts, searchStr, showEnabledOnly);
      setVisible(filtered.slice((prev - 1) * PAGE_SIZE, prev * PAGE_SIZE));
      setPage(prev);
    }
  };

  const filter = (e) => {
    const q = (e.target.value || '').toLowerCase();
    setSearchStr(q);
    const filtered = applyFilters(discounts, q, showEnabledOnly);
    setVisible(filtered.slice(0, PAGE_SIZE));
    setIsFiltered(!!q || showEnabledOnly);
    setPage(1);
  };

  const toggleShowEnabled = () => {
    const newShow = !showEnabledOnly;
    setShowEnabledOnly(newShow);
    const filtered = applyFilters(discounts, searchStr, newShow);
    setVisible(filtered.slice(0, PAGE_SIZE));
    setIsFiltered(!!searchStr || newShow);
    setPage(1);
  };

  return (
    <div id="main-discount-list" className="container-fluid page">
      <NavBar cart={props.cart} isLogIn={props.isLogIn} />
      <Breadcrumb page="discounts-admin" items={breadcrumbItems} />

      <div className="d-flex align-items-center mb-2">
        <Search
          text="Buscar"
          placeholder="Buscar descuento por Título, Tipo, Valor, Marca, Producto o Fecha"
          searchCallback={filter}
          value={searchStr}
        />
        <div style={{ marginLeft: 12 }}>
          <button
            type="button"
            className={`btn btn-sm ${showEnabledOnly ? 'btn-success' : 'btn-outline-secondary'}`}
            onClick={toggleShowEnabled}
          >
            {showEnabledOnly ? 'Mostrando sólo habilitados' : 'Mostrar solo habilitados'}
          </button>
        </div>
      </div>

      {generateList(visible)}

      <PageControls
        isFiltered={isFiltered}
        currentPage={page}
        nextPageHandler={nextPage}
        prevPageHandler={prevPage}
        totalPages={discounts ? Math.ceil(applyFilters(discounts, searchStr, showEnabledOnly).length / PAGE_SIZE) : 0}
      />
    </div>
  );
};

export default DiscountListPage;
